// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Camera Effects Container Overlay */
.camera-effects-container {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 5;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ── Atmospheric Backdrops / Vignette ── */
.camera-backdrop-vignette {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at center, transparent 40%, rgba(0, 0, 0, 0.75) 100%);
  pointer-events: none;
}

.camera-backdrop-cyber {
  position: absolute;
  inset: 0;
  box-shadow: inset 0 0 40px rgba(0, 240, 255, 0.4), inset 0 0 15px rgba(255, 0, 128, 0.3);
  border: 2px solid rgba(0, 240, 255, 0.3);
  pointer-events: none;
}

/* ── Face Accessories ── */
.camera-accessory-item {
  position: absolute;
  pointer-events: none;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.6));
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Sunglasses (Eye level) */
.camera-accessory-item.accessory-glasses {
  top: 38%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 48%;
  max-width: 190px;
}

/* Royal Crown (Above head) */
.camera-accessory-item.accessory-crown {
  top: 14%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 42%;
  max-width: 160px;
  animation: crown-float 3s ease-in-out infinite alternate;
}

@keyframes crown-float {
  0% { transform: translate(-50%, -50%) translateY(0); }
  100% { transform: translate(-50%, -50%) translateY(-5px); }
}

/* Gamer RGB Headset */
.camera-accessory-item.accessory-headset {
  top: 28%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 68%;
  max-width: 270px;
}

/* Gentleman Mustache */
.camera-accessory-item.accessory-mustache {
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 32%;
  max-width: 120px;
}

/* Cyber Visor */
.camera-accessory-item.accessory-cyber {
  top: 38%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 52%;
  max-width: 200px;
  animation: cyber-pulse 2s ease-in-out infinite alternate;
}

@keyframes cyber-pulse {
  0% { filter: drop-shadow(0 0 8px rgba(0, 240, 255, 0.6)); }
  100% { filter: drop-shadow(0 0 16px rgba(255, 0, 127, 0.8)); }
}

/* Live Camera Video styling with filters & mirrors */
.meci-local-camera-video {
  transition: filter 0.3s ease, transform 0.2s ease;
}
`, "",{"version":3,"sources":["webpack://./src/components/CameraEffectsOverlay.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,QAAQ;EACR,wFAAwF;EACxF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,wFAAwF;EACxF,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kDAAkD;EAClD,uDAAuD;AACzD;;AAEA,2BAA2B;AAC3B;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,KAAK,8CAA8C,EAAE;EACrD,OAAO,iDAAiD,EAAE;AAC5D;;AAEA,sBAAsB;AACtB;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,KAAK,mDAAmD,EAAE;EAC1D,OAAO,oDAAoD,EAAE;AAC/D;;AAEA,qDAAqD;AACrD;EACE,iDAAiD;AACnD","sourcesContent":["/* Camera Effects Container Overlay */\n.camera-effects-container {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  z-index: 5;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ── Atmospheric Backdrops / Vignette ── */\n.camera-backdrop-vignette {\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at center, transparent 40%, rgba(0, 0, 0, 0.75) 100%);\n  pointer-events: none;\n}\n\n.camera-backdrop-cyber {\n  position: absolute;\n  inset: 0;\n  box-shadow: inset 0 0 40px rgba(0, 240, 255, 0.4), inset 0 0 15px rgba(255, 0, 128, 0.3);\n  border: 2px solid rgba(0, 240, 255, 0.3);\n  pointer-events: none;\n}\n\n/* ── Face Accessories ── */\n.camera-accessory-item {\n  position: absolute;\n  pointer-events: none;\n  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.6));\n  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Sunglasses (Eye level) */\n.camera-accessory-item.accessory-glasses {\n  top: 38%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 48%;\n  max-width: 190px;\n}\n\n/* Royal Crown (Above head) */\n.camera-accessory-item.accessory-crown {\n  top: 14%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 42%;\n  max-width: 160px;\n  animation: crown-float 3s ease-in-out infinite alternate;\n}\n\n@keyframes crown-float {\n  0% { transform: translate(-50%, -50%) translateY(0); }\n  100% { transform: translate(-50%, -50%) translateY(-5px); }\n}\n\n/* Gamer RGB Headset */\n.camera-accessory-item.accessory-headset {\n  top: 28%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 68%;\n  max-width: 270px;\n}\n\n/* Gentleman Mustache */\n.camera-accessory-item.accessory-mustache {\n  top: 55%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 32%;\n  max-width: 120px;\n}\n\n/* Cyber Visor */\n.camera-accessory-item.accessory-cyber {\n  top: 38%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 52%;\n  max-width: 200px;\n  animation: cyber-pulse 2s ease-in-out infinite alternate;\n}\n\n@keyframes cyber-pulse {\n  0% { filter: drop-shadow(0 0 8px rgba(0, 240, 255, 0.6)); }\n  100% { filter: drop-shadow(0 0 16px rgba(255, 0, 127, 0.8)); }\n}\n\n/* Live Camera Video styling with filters & mirrors */\n.meci-local-camera-video {\n  transition: filter 0.3s ease, transform 0.2s ease;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
